import React from "react";
import { NotAvailable } from "lib/SimpleTable";
import ErrorBoundary from "lib/ErrorBoundary";
import { SubscriptionsProvider } from "lib/hooks/useSubscriptions/subscriptionsContext";
import { ViewLayoutRedesign } from "./viewLayout/ViewLayoutRedesign";
import { useJSFetchPublications } from "./publications/api/direct/useJSFetchPublications";
import { useCreateSearchRequest } from "./publications/api/searchRequest/useCreateSearchRequest";
import { SectorSubSectorDataProvider } from "./viewLayout/sidePanel/sectorSubSectorDataProvider";
import { useGetThemeInFocus } from "components/ThemeInFocus/api/useGetThemeInFocus";

import "./redesign_dict_ja";

function Redesign() {
  const searchRequest = useCreateSearchRequest();
  const searchResults = useJSFetchPublications(searchRequest);
  const { themes: themeInFocusData } = useGetThemeInFocus();
  const error = searchResults?.[2];

  if (error) return <NotAvailable />;

  return (
    <ErrorBoundary>
      <SubscriptionsProvider>
        <SectorSubSectorDataProvider>
          <ViewLayoutRedesign searchResults={searchResults} themeInFocusData={themeInFocusData} />
        </SectorSubSectorDataProvider>
      </SubscriptionsProvider>
    </ErrorBoundary>
  );
}

export default Redesign; // must be a default export for code splitting
